import { render } from "./SeasonArchive.vue?vue&type=template&id=33df5c0e"
import script from "./SeasonArchive.vue?vue&type=script&lang=js"
export * from "./SeasonArchive.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__